import React, { useEffect, useMemo, useRef, useState } from 'react';
import { subscribeToSnacks } from '../../utils/snackbarBus';
import './SnackbarHost.css';

const DEFAULT_DURATION_MS = 2800;

function getVariantLabel(variant) {
  switch (variant) {
    case 'error':
      return 'Error';
    case 'warning':
      return 'Aviso';
    case 'info':
      return 'Info';
    case 'success':
    default:
      return 'OK';
  }
}

export default function SnackbarHost() {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);
  const timerRef = useRef(null);

  const hasCurrent = !!current;
  const next = useMemo(() => (queue.length ? queue[0] : null), [queue]);

  useEffect(() => {
    return subscribeToSnacks((snack) => {
      if (!snack?.message) return;
      setQueue((prev) => [...prev, snack]);
    });
  }, []);

  useEffect(() => {
    if (hasCurrent) return;
    if (!next) return;
    setCurrent(next);
    setQueue((prev) => prev.slice(1));
  }, [hasCurrent, next]);

  useEffect(() => {
    if (!current) return;

    const durationMs = Number.isFinite(current.durationMs) ? current.durationMs : DEFAULT_DURATION_MS;
    timerRef.current = window.setTimeout(() => setCurrent(null), durationMs);

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = null;
    };
  }, [current]);

  if (!current) return null;

  const variant = current.variant || 'success';
  const label = getVariantLabel(variant);

  return (
    <div className="snackbar-host" role="status" aria-live="polite">
      <div className={`snackbar snackbar--${variant}`}>
        <div className="snackbar__label">{label}</div>
        <div className="snackbar__message">{current.message}</div>
      </div>
    </div>
  );
}

